<template>
	<div class="uupay-container">

    <price-banner banner-img="price_banner">
      <template v-slot:title>
        <div class="banner-title-uu">特低手續費</div>
      </template>
      <template v-slot:subtitle>
        絕無隱藏收費
      </template>
      <template v-slot:info>
        完整的收付系統，以特低的服務費滿足您的企業需求 
      </template>
    </price-banner>

    <section class="modules-section">
      <div class="container modules-section-container">
        <div class="row d-flex justify-content-center">
          <div class="title">
            選擇你的行業
          </div>
        </div>
        <!-- <div class="row">
          <div class="horizontal-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in items" :key="index">
                <div class="slide-content">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div> -->
        <div class="row">
          <div class="business-content d-flex justify-content-around">
            <div v-for="(item, index) in business" :key="index">
              <div 
                class="business d-flex justify-content-center align-items-center" 
                :class="{'business-selected': stepIndex == index }"
                @click="clickBusiness(index)"
              >{{ item }}</div>
            </div>
          </div>
        </div>
        <div class="business-body" v-for="item in stepList">
          <div class="row">
            <div class="col">
              <div class="business-body-title d-flex justify-content-center align-items-center">{{ item.title }}</div>
            </div>
          </div>
          <div class="row business-body-content" v-for="content in item.content">
            <div class="col-md-5">
              <div class="business-body-key d-flex justify-content-center align-items-center">
                {{ content.title }}
              </div>
            </div>
            <div class="col-md-7">
              <div class="business-body-value" >
                <div class="business-body-value-content d-flex justify-content-between" v-for="info in content.info">
                  <div class="business-body-item-left d-flex align-items-center">
                    <div class="business-body-item">{{ info.key }}</div>
                    <div class="business-body-item business-body-item-icon" v-if="info.isIcon">
                      <img :src="plusCircleIcon" alt="SVG Icon">
                    </div>
                  </div>
                  <div class="business-body-item-right">
                    <div class="business-body-item" v-if="info.value === true">
                      <img :src="checkIcon" alt="SVG Icon" >
                    </div>
                    <div class="business-body-item" v-else>
                      {{ info.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </div>
</template>
<script>
import PriceBanner from "@/components/PriceBanner";
import Swiper, { Navigation, Pagination } from 'swiper'

export default {
  name: 'UUPayPrice',
  components: {
    PriceBanner,
  },
  data() {
    return {
      plusCircleIcon: require('@/assets/uupay/icon/svg/plus_circle_magenta.svg'),
      checkIcon: require('@/assets/uupay/icon/svg/check_magenta.svg'),

      business: ['餐飲', '雜貨店', '醫療', '零售', '慈善', '教育' ],
      stepIndex: 0,
      stepList: [
        { title: '登記', 
          content: [ 
            { title: '登記所需的基本訊息', info: [
              { key: '商業文件（BR、CI、NAR1）', value: true, isIcon: false },
              { key: '店鋪照片', value: true, isIcon: false },
              { key: '監管許可', value: true, isIcon: false },
              { key: '地點證明', value: true, isIcon: false },
              { key: '銀行證明', value: true, isIcon: false },
            ]},
          ],
        },
        { title: '付款受理範圍', 
          content: [ 
            { title: '離線支付範圍', info: [
              { key: '二維碼', value: true, isIcon: true },
              { key: '信用卡', value: true, isIcon: true },
              { key: '轉數快', value: true, isIcon: true },
              { key: '八達通', value: true, isIcon: true },
            ]},
            { title: '網上付款接受範圍', info: [
              { key: '二維碼', value: true, isIcon: true },
              { key: '信用卡', value: true, isIcon: true },
              { key: '轉數快', value: true, isIcon: true },
              { key: '八達通', value: true, isIcon: true },
            ]},
            { title: '離線支付方式', info: [
              { key: '實體POS卡機', value: true, isIcon: false },
              { key: 'Sfotpos 卡機', value: true, isIcon: true },
            ]},
            { title: '網上支付方式', info: [
              { key: '二維碼支付站連結', value: true, isIcon: false },
              { key: '發票付款連結', value: true, isIcon: false },
            ]},
            { title: '線下商家折扣率', info: [
              { key: '本地二維碼', value: '1.20%', isIcon: true },
              { key: '本地信用卡', value: '1.45%', isIcon: true },
              { key: '非本地二維碼', value: '1.20%', isIcon: true },
              { key: '非本地信用卡', value: '1.45%', isIcon: true },
              { key: '轉數快', value: '1.50%', isIcon: true },
            ]},
            { title: '網上商戶折扣率', info: [
              { key: '實體POS卡機', value: '1.70%', isIcon: true },
              { key: '本地信用卡', value: '1.70%', isIcon: true },
              { key: '非本地二維碼', value: '1.70%', isIcon: true },
              { key: '非本地信用卡', value: '1.70%', isIcon: true },
              { key: '轉數快', value: '1.50%', isIcon: true },
            ]},
            { title: '網上商戶折扣率', info: [
              { key: '開戶費', value: '豁免', isIcon: false },
              { key: 'Wonder Smart 卡機費用', value: 'HK$1,000', isIcon: false },
              { key: 'Wonder Mini 卡機費用', value: 'HK$250', isIcon: true },
              { key: '年費', value: '豁免', isIcon: false },
            ]},
          ] 
        },
        { title: '商業卡發行服務', 
          content: [ 
            { title: '支援的商業卡類型', info: [
              { key: '行政卡', value: true, isIcon: true },
              { key: '消費卡', value: true, isIcon: true },
            ]},
            { title: '商業卡發行服務相關服務', info: [
              { key: '每張虛擬卡發行成本', value: '豁免', isIcon: false },
              { key: '普通卡發卡費', value: 'HK$79 每張', isIcon: false },
              { key: '金屬卡發卡費', value: 'HK$799 每張', isIcon: false },
              { key: '年費', value: '豁免', isIcon: false },
              { key: '本地教育手續費', value: '豁免', isIcon: false },
              { key: '本地交易費', value: '豁免', isIcon: false },
              { key: '本地交易外匯兌換費', value: '豁免', isIcon: false },
              { key: '國際交易手續費', value: '豁免', isIcon: false },
              { key: '國際交易費', value: '豁免', isIcon: false },
              { key: '國際交易外匯兌換費', value: '1.50%', isIcon: false },
              { key: '本地ATM提款手續費', value: 'HK$19.90 每筆', isIcon: false },
              { key: '本地ATM提款費', value: '1.95% 每筆', isIcon: false },
              { key: '本地ATM提款外匯費用', value: '豁免', isIcon: false },
              { key: '國際ATM提款手續費', value: 'HK$19.90 每筆', isIcon: false },
              { key: '國際ATM提款費用', value: '1.95% 每筆', isIcon: false },
              { key: '國際ATM提款外匯兌換費', value: '1.50% 每筆', isIcon: false },
            ]},
          ],
        },
        { title: '支援數位金融服務', 
          content: [ 
            { title: '數位金融服務', info: [
              { key: '虛擬帳戶', value: true, isIcon: false },
              { key: '外匯', value: true, isIcon: false },
              { key: '匯款', value: true, isIcon: false },
            ]},
            { title: '數位金融服務相關費用', info: [
              { key: '每個帳戶的虛擬帳戶開戶費', value: '豁免', isIcon: true },
              { key: '外匯服務費', value: '0.15% 每筆', isIcon: true },
              { key: '匯款服務費', value: '豁免', isIcon: true },
            ]},
          ],
        },
        { title: '增值商家服務', 
          content: [ 
            { title: '增值商家服務相關費用', info: [
              { key: 'T+0', value: '0.10%', isIcon: true },
              { key: 'Bindo Smar+POS', value: '0.10%', isIcon: true },
              { key: '標準 ECR 整合一次性設定費用', value: 'HK$5,000', isIcon: false },
              { key: '自訂 ECR 整合一次性設定費用', value: '可根據要求提供', isIcon: false },
            ]},
          ],
        },
        { title: '交易限額', 
          content: [ 
            { title: '付款接受交易限額', info: [
              { key: '每筆交易', value: '無限', isIcon: false },
              { key: '每日總交易量', value: '無限', isIcon: false },
              { key: '每月總交易量', value: '無限', isIcon: false },
            ]},
            { title: '商業卡交易限額', info: [
              { key: '支援的商業卡數量', value: '無限', isIcon: false },
              { key: '單筆交易', value: '無限', isIcon: false },
              { key: '每日總交易量', value: '無限', isIcon: false },
              { key: '每月總交易量', value: '無限', isIcon: false },
              { key: '本地現金提款限額', value: '無限', isIcon: false },
              { key: '國際現金提款限額', value: '無限', isIcon: false },
            ]},
          ],
        },
        
      ],

      items: [
        { title: '幻灯片1', description: '这是第一个幻灯片的内容' },
        { title: '幻灯片2', description: '这是第二个幻灯片的内容' },
        { title: '幻灯片3', description: '这是第三个幻灯片的内容' },
        { title: '幻灯片4', description: '这是第四个幻灯片的内容' },
        { title: '幻灯片5', description: '这是第五个幻灯片的内容' }
      ],
      swiperInstance: null
    }
  },
  methods: {
    clickBusiness(index) {
      this.stepIndex = index
    },
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log('slide change');
    },
    initSwiper() {
      this.swiperInstance = new Swiper('.horizontal-swiper-container', {
        direction: 'horizontal', // 水平方向(默认值，可省略)
        slidesPerView: 3,       // 同时显示的幻灯片数量
        spaceBetween: 30,       // 幻灯片间距
        loop: true,             // 循环模式
        centeredSlides: true,   // 活动幻灯片居中
        autoplay: {             // 自动播放
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {           // 分页器
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {         // 响应式断点
          640: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          },
        }
      })
    }
  },
  beforeDestroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true)
    }
  },
  mounted() {
    // new Swiper(this.$refs.bannerSwiper, {
    //   // configure Swiper to use modules
    //   modules: [Navigation, Pagination],
    //   // Optional parameters
    //   // loop: true,
    //   direction: 'vertical',
    //   mousewheel: true,

    //   // If we need pagination
    //   direction: 'vertical', // 垂直切换选项
    //   pagination: {
    //     el: '.swiper-pagination',
    //   },

    //   // Navigation arrows
    //   navigation: {
    //     nextEl: '.banner-next',
    //     prevEl: '.banner-prev',
    //   },

    //   // And if we need scrollbar
    //   scrollbar: {
    //     el: '.swiper-scrollbar',
    //   },
    // })
    
    this.initSwiper()
  }
}
</script>
<style scoped>


.modules-section {
  margin: 3rem 0 7rem 0;
  color: #21042e;
}

.modules-section .title {
  font-size: 42px;
  line-height: 60px;
  font-weight: 600;
  margin: 1.2rem 0;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}

.modules-section .business-content {
  width: 100%;
  margin: 2rem 0;
}
.modules-section .business {
  width: 120px;
  height: 50px;

  background-color: #f8f8f8;
  border-radius: 50px;
  border: #f5f5f5 1px solid;

  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.modules-section .business-selected {
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  color: #fff;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.business-body {
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
}
.business-body-title {
  width: 100%;
  height: 60px;
  color: #fff;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  border-radius: 10px;
  margin: 1.2rem 0;
}
.business-body-content {
  margin-bottom: 1.2rem;
}
.business-body-key {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: #f5f5f5 1px solid;
  width: 100%;
  height: 100%;
}
.business-body-value {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: #f5f5f5 1px solid;
  width: 100%;
  
}
.business-body-value-content {
  margin: 3rem;
}
.business-body-item-left {

}
.business-body-item-right {

}
.business-body-item {

}
.business-body-item-icon {
  margin-left: 0.4rem;
}

.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}

.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}


.horizontal-swiper-container {
  width: 100%;
  height: 300px;
  margin: 20px auto;
}

.swiper-slide {
  text-align: center;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.slide-content {
  padding: 20px;
  width: 100%;
}

.swiper-slide h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.swiper-slide p {
  font-size: 1rem;
  color: #666;
}

/* 分页器样式 */
.swiper-pagination /deep/ .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: #999;
  opacity: 1;
}

.swiper-pagination /deep/ .swiper-pagination-bullet-active {
  background: #1890ff;
}
</style>


// WEBPACK FOOTER //
// src/views/uupayPrice.vue